<template>
  <div class="ad-box">
    <el-carousel height="245px">
      <el-carousel-item v-for="(item,index) in list" :key="index">
        <a :href="item.link" target="_blank"
          ><div
            class="ad-item"
            v-bind:style="{ backgroundImage: 'url(' + item.url + ')' }"
          ></div
        ></a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: ['topAdList'],
  data() {
    return {
      list: []
    }
  },
  created() {
    if (this.topAdList) {
      this.list = this.topAdList
    }
  },
  watch: {
    topAdList(val) {
      this.list = val
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-box {
  .ad-item {
    height: 245px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/practice/ad/top.vue